import React, { useEffect } from "react";
import "./Arrays.css";

function Arrays() {
  useEffect(() => {
    const handleScroll = () => {
      document.querySelectorAll(".fade-in").forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight - 100) {
          el.classList.add("visible");
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="home-page">

      {/* HERO */}
      <section className="hero-section fade-in">
        <div className="container">
          <h6 className="hero-subtitle">| Pyramid Construction</h6>

          <h1 className="hero-title">
            نبني بثقة  
            <span>ونُشطب باحتراف</span>
          </h1>

          <p className="hero-text">
            شركة متخصصة في <strong>التشطيبات والمقاولات العامة</strong>،
            نُقدّم حلول متكاملة بجودة عالية، التزام بالمواعيد،
            وتشطيبات تليق باسمك.
          </p>

<div className="hero-buttons">
  <a 
    href="https://wa.me/201095176686?text=أريد طلب معاينة لمشروع Pyramid" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    اطلب معاينة
  </a>
</div>
        </div>
      </section>


      {/* SERVICES */}
      <section className="services-section fade-in">
        <div className="container">
          <h2 className="section-title">خدماتنا</h2>

          <div className="services-grid">
            <div className="service-card">
              <span>🏗️</span>
              <h4>مقاولات عامة</h4>
              <p>
                تنفيذ مشاريع سكنية وتجارية بأعلى معايير الجودة
                وبإدارة هندسية محترفة.
              </p>
            </div>

            <div className="service-card">
              <span>🎨</span>
              <h4>تشطيبات متكاملة</h4>
              <p>
                تشطيبات سوبر لوكس – لوكس – اقتصادي
                بأحدث الخامات والتصميمات.
              </p>
            </div>

            <div className="service-card">
              <span>📐</span>
              <h4>تصميم وتنفيذ</h4>
              <p>
                تصميمات داخلية وخارجية
                تجمع بين الجمال والعملية.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* VIDEO */}
<section className="video-section fade-in">
  <div className="video-container">
    <video
      className="vertical-video"
      autoPlay
      loop
      muted
      playsInline
      preload="metadata"
      poster="/assets/images/video-cover.jpg"
    >
      <source src="/assets/images/jasmine.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
</section>

    </div>
  );
}

export default Arrays;
